import { render } from "./RecommendedPhotoAngle.vue?vue&type=template&id=7b46ceed&scoped=true"
import script from "./RecommendedPhotoAngle.vue?vue&type=script&lang=js"
export * from "./RecommendedPhotoAngle.vue?vue&type=script&lang=js"

import "./RecommendedPhotoAngle.vue?vue&type=style&index=0&id=7b46ceed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b46ceed"]])

export default __exports__